<template>
    <div>
        <div class="main-content">
            <h1>Vitajte v Maxman online zóne</h1>
            <div class="heading-spliter"></div>
            <div class="text-mute">
                Maxman online zóna je virtuálny priestor, v ktorom môžete pracovať na svojom profesionálnom a osobnostnom rozvoji. <br/><br/>
                Rozvíjať sa môžete kedykoľvek a kdekoľvek s našimi interaktívnymi formami vzdelávania. 
            </div>
            <div class="categories">
                <div class="category">
                    <div class="top-box">
                        O
                        <div class="border-box top"></div>
                    </div>
                    <div class="category-content">
                        <h2>Online spätná väzba </h2>
                        <span class="text-mute">
                            Online hodnotiaci nástroj, s ktorým zrealizujete akýkoľvek prieskum či spätnú väzbu vo vašej spoločnosti.<br><br>
                        </span>
                        <router-link class="button" :to="{name: 'feedback_all'}" >
                            Vstúpiť
                        </router-link>
                    </div>
                </div>
                <div class="category">
                    <div class="top-box">
                        D
                        <div class="border-box right"></div>
                    </div>
                    <div class="category-content">
                        <h2>Dotazníky</h2>
                        <span class="text-mute">
                            Psychodiagnostické a osobnostné dotazníky, ktoré vám pomôžu lepšie spoznať svoje osobnostné preferencie a charakteristiky. 
                        </span>
                        <router-link class="button" :to="{name: 'questionary_all'}" >
                            Vstúpiť
                        </router-link>
                    </div>
                </div>
                <div class="category">
                    <div class="top-box">
                        V
                        <div class="border-box left"></div>
                    </div>
                    <div class="category-content">
                        <h2>Videozóna</h2>
                        <span class="text-mute">
                            Vzdelávacie video-tutoriály, prostredníctvom ktorých si zlepšíte svoje manažérske, obchodnícke a tímové zručnosti.
                        </span>
                        <router-link class="button" :to="{name: 'videozone'}" >
                            Vstúpiť
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        components: {

        },
        mixins: [],
        data: () => ({
                loading: false,
                model: null
            }),
        mounted() {

        },
        created() {
            this.load();
        },
        watch: {

        },
        computed: {

        },
        methods: {
            load() {
                this.$api.server.post("api/public/dashboard").then((r) => {
                    this.model = r.data;

                });
            }
        }


    };
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/public_app/pages/dashboard/Dashboard.vue